<dl class="pricing-block-cards">
  <div
    class="pricing-block-card"
    grooveSurface
    variant="bordered"
    tone="raised"
    size="lg"
  >
    <dt class="pricing-block-card-name">Hourly Rate</dt>
    <dd class="pricing-block-card-body">
      <p class="pricing-block-card-price">
        <span class="pricing-block-card-amount groove-type-display">{{
          hourly()
        }}</span>
        <span class="pricing-block-card-unit">/ hour</span>
      </p>
      <p class="pricing-block-card-note">{{ hourlyNote() }}</p>
    </dd>
  </div>
  <div
    class="pricing-block-card"
    grooveSurface
    variant="bordered"
    tone="raised"
    size="lg"
  >
    <dt class="pricing-block-card-name">Prepaid Rate</dt>
    <dd class="pricing-block-card-body">
      <p class="pricing-block-card-price">
        <span class="pricing-block-card-amount groove-type-display">{{
          prepaid()
        }}</span>
        <span class="pricing-block-card-unit">/ hour</span>
        @if (savingsLine()) {
          <span class="pricing-block-card-savings"
            >&middot; {{ savingsLine() }}</span
          >
        }
      </p>
      <p class="pricing-block-card-note">{{ prepaidNote() }}</p>
    </dd>
  </div>
</dl>

<div class="pricing-block-methods">
  <p class="pricing-block-methods-label">Payment methods</p>
  <ul class="pricing-block-methods-list">
    @for (method of paymentMethods(); track method) {
      <li>{{ method }}</li>
    }
  </ul>
</div>

@if (policiesLink(); as policies) {
  <p class="pricing-block-policies">
    <a
      class="groove-text-link groove-ring"
      data-tone="accent"
      [routerLink]="policies.path"
      [fragment]="policies.fragment"
    >
      Scheduling &amp; cancellation policies
    </a>
  </p>
}
